
<div [chart]="chart"></div>

<div *ngIf="noData">
    <span class="no_data"> {{"NO_DATA" | translate}}</span>
</div>